import { i18nFormat as e } from "../../../constants/i18n.js";
import { intervalToDuration as _ } from "date-fns";
import t from "i18next";
import * as s from "ramda";
const N = (n, r) => {
  if (s.startsWith(e.FromNow, r)) {
    const o = Number(n);
    if (!isNaN(o)) {
      const {
        years: m = 0,
        months: i = 0,
        days: a = 0,
        hours: u = 0,
        minutes: f = 0,
        seconds: c = 0
      } = _({
        start: 0,
        end: Number(n) * 1e3
        // value must be in seconds
      });
      return m > 0 ? t.t("common.i18n_format.year", { count: m }) : i > 0 ? t.t("common.i18n_format.month", { count: i }) : a > 0 ? t.t("common.i18n_format.day", { count: a }) : u > 0 ? t.t("common.i18n_format.hour", { count: u }) : f > 0 ? t.t("common.i18n_format.minute", { count: f }) : c > 0 ? t.t("common.i18n_format.second", { count: c }) : t.t("common.i18n_format.just_now", { count: c });
    }
  }
  return null;
}, y = (n, r) => {
  if (s.startsWith(e.Ordinal, r)) {
    const o = Number(n);
    if (!isNaN(o))
      switch (o) {
        case 1:
          return t.t("common.i18n_format.ordinal_one", { count: o });
        case 2:
          return t.t("common.i18n_format.ordinal_two", { count: o });
        case 3:
          return t.t("common.i18n_format.ordinal_three", { count: o });
        default:
          return o >= 4 ? t.t("common.i18n_format.ordinal_many", { count: o }) : t.t("common.i18n_format.ordinal_zero", { count: o });
      }
  }
  return null;
}, p = (n, r) => {
  if (s.startsWith(e.RoundDays, r)) {
    const o = Number(n);
    if (!isNaN(o)) {
      const m = o / 86400;
      if (m >= 1)
        return t.t("common.i18n_format.day", {
          count: m
        });
      const i = o % (60 * 60 * 24);
      if (i >= 1)
        return t.t("common.i18n_format.hour", { count: i });
      const a = o % (60 * 60);
      if (a >= 0)
        return t.t("common.i18n_format.minute", { count: a });
      const u = o % 60;
      if (u >= 0)
        return t.t("common.i18n_format.second", { count: u });
    }
  }
  return null;
};
export {
  y as formatOrdinal,
  N as formatRelativeTime,
  p as formatRoundDays
};
//# sourceMappingURL=format.js.map
